var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgMessage = function SvgMessage(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.27 22.48c.48.35 1.2.54 1.74.78 2.85 1.28 5.69 2.56 8.54 3.84 1.22.55 2.45 1.1 3.67 1.65.69.31 1.49.84 2.24.62.63-.18 1.28-.6 1.88-.87 1.26-.57 2.52-1.13 3.78-1.7l8.46-3.81c.71-.32 1.38-.48 1.73-1.25.57-1.23.21-3.27-1.33-3.44-1.51-.17-3.14 0-4.65 0H17.01c-1.77.23-2.08 3.19-.74 4.16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M47.87 24.99c-4.66 1.93-9.31 3.86-13.95 5.85-.64.28-1.28.6-1.94.86a.479.479 0 0 1-.11-.05c-.31-.17-.69-.27-1.02-.39-2.74-1.05-5.47-2.1-8.21-3.15-2.16-.83-4.33-1.66-6.49-2.49-.56-.22-.67.84-.67 1.16 0 3.34.05 6.67.13 10.01.06 2.37.13 1.74.28 4.1.08 1.32 0 3.12.6 4.34.35.69.92.51 1.59.51H47c.1 0 .18-.04.25-.11.56-.42.61-1.83.67-2.35.2-1.68.26-.38.33-2.07.17-4.04.23-8.08.26-12.12 0-.98.02-1.95.02-2.93 0-.3-.11-1.39-.67-1.16Z"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgMessage);
export default ForwardRef;